import React from 'react';
import PropTypes from 'prop-types';

import TransactionKey from "../../components/TransactionKey";

import TextDate from "components/text/TextDate";
import TextAmount from "components/text/TextAmount";
import TextPercentage from "components/text/TextPercent";



class CollectionFee extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      highlight : props.highligh
    }
  };


  render() {      
    let collectionFee = this.props.data;
    // console.log("CollectionFee", this.props.data);
    let shouldHighlightClass = (this.state.highlight ? "calc-setting-table calc-setting-table-highlight" : "calc-setting-table" );
    return ( 
    
        <div className={shouldHighlightClass}>            
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <tbody>
          <tr>
            <th className="text-right">Gildir frá</th>
            <td className="text-right"><TextDate value={collectionFee.validFromDate}/></td>
            <th className="text-right">&nbsp;</th>
            <td className="text-right">&nbsp;</td>
            <th className="text-right">&nbsp;</th>
          </tr>
          <tr>
            <th className="text-right">Grunngjald</th>
            <td className="text-right"><TextAmount value={collectionFee.collectionBaseFee}/></td>
            <th className="text-right">&nbsp;</th>
            <td className="text-right">&nbsp;</td>
          </tr>
          <tr>
            <th className="text-right">Færslulykill</th>
            <td className="text-right">
              <TransactionKey data={this.props.transactionKey}/>
            </td>
            <th className="text-right">&nbsp;</th>
            <td className="text-right">&nbsp;</td>
          </tr>

          <tr>
            <th colSpan="5" className="text-left">Innheimtustig:</th>
          </tr>
          <tr>
            <th colSpan="2" className="text-left">Prósenta eða krónutala</th>
            <th className="text-right">Upphæð</th>
            <th colSpan="2" className="text-left">&nbsp;</th>
          </tr>

          {collectionFee.collectionFeeIncrementals.map(function(item,i){
            return(
              <tr key={i}>
                <td className="text-right"><TextPercentage value={item.percentage}/></td>
                <td className="text-right"><TextAmount value={item.pointAmount}/></td>
                <td className="text-right"><TextAmount value={item.amount}/></td>
                <td className="text-right">&nbsp;</td>
                <td className="text-right">&nbsp;</td>
              </tr>);
          })}
          {/* <tr className="calc-setting-table-splitline">
            <td  colSpan="5">&nbsp;</td>
          </tr> */}
          </tbody>
        </table>


      </div>
    );
  }
}

CollectionFee.propTypes = {
  data : PropTypes.object,
  transactionKey : PropTypes.object,
  highligh : PropTypes.bool
};



export default CollectionFee;
